export interface FaqItem {
  id: string
  question: string
  answer: string
  category: string
}

export interface TutorialItem {
  id: string
  title: string
  videoId: string
  category: string
}

export const FAQ_CATEGORIES = [
  { id: 'general', label: 'common.general' },
  { id: 'tipsters', label: 'competitions.createForTipsters' },
  { id: 'users', label: 'supportBottomSheet.category.forUsers' },
  { id: 'navigation', label: 'supportBottomSheet.category.navigation' },
]

export const TUTORIAL_CATEGORIES = [
  { id: 'general', label: 'common.general' },
  { id: 'tipsters', label: 'competitions.createForTipsters' },
  { id: 'users', label: 'supportBottomSheet.category.forUsers' },
  { id: 'navigation', label: 'supportBottomSheet.category.navigation' },
]

export const TUTORIALS_DATA: TutorialItem[] = [
  {
    id: '1',
    title: 'Everything you need to know about tipsters - Tipsterizer',
    videoId: 'h9I91yCXkjU',
    category: 'general',
  },
  {
    id: '2',
    title: 'Everything you need to know about tipsters - Tipsterizer',
    videoId: 'UP7SHv3mt-U',
    category: 'general',
  },
  {
    id: '3',
    title: 'Everything you need to know about tipsters - Tipsterizer',
    videoId: '6a_mjjKs8oo',
    category: 'general',
  },
  {
    id: '4',
    title: 'Everything you need to know about tipsters - Tipsterizer',
    videoId: 'xYLH8lHFs6A',
    category: 'general',
  },
]

export const FAQ_DATA: FaqItem[] = [
  {
    id: '1',
    question: 'Who is a Tipster?',
    answer: 'A tipster is someone who regularly provides sports betting information (tips) on the likely outcomes of sporting events.',
    category: 'general',
  },
  {
    id: '2',
    question: 'What is a bankroll?',
    answer: 'A bankroll is the total amount of money you have set aside specifically for betting purposes.',
    category: 'general',
  },
  {
    id: '3',
    question: 'Where do I vote on events?',
    answer: 'You can vote on events by navigating to the Voting section in the main menu and selecting the event you want to vote on.',
    category: 'navigation',
  },
  {
    id: '4',
    question: 'Why can\'t I download Tipsterizer from the app store?',
    answer: 'Tipsterizer is a progressive web app (PWA). You can install it directly from your browser by clicking the install button or adding it to your home screen.',
    category: 'general',
  },
  {
    id: '5',
    question: 'Public channel explained',
    answer: 'A public channel is a free channel where tipsters can share their tips and insights with all users. Anyone can join and view the content.',
    category: 'tipsters',
  },
  {
    id: '6',
    question: 'How can I join a tipster channel?',
    answer: 'To join a tipster channel, navigate to the Channels section, find the channel you want to join, and click the Join button.',
    category: 'users',
  },
  {
    id: '7',
    question: 'How can I subscribe to a tipster?',
    answer: 'To subscribe to a tipster, visit their profile page and click the Subscribe button. You may need to complete a payment if it is a paid subscription.',
    category: 'users',
  },
  {
    id: '8',
    question: 'Do my correct votes count for anything?',
    answer: 'Yes! Your correct votes contribute to your overall statistics and can help you climb the leaderboards.',
    category: 'general',
  },
  {
    id: '9',
    question: 'Can I create a post, poll, tip in the public channel?',
    answer: 'Only verified tipsters can create posts, polls, and tips in channels. Users can interact with content by voting and commenting.',
    category: 'tipsters',
  },
]
